import { observer } from 'mobx-react-lite'
import { type OCRScopeWork } from '@/features/jobs/scoping/OCRScopeWork'
import { type OCRScopingJobMainPanelViewModel } from '@/features/jobs/scoping/OCRScopingJobMainPanelViewModel'
import { type OCRScopingJobBulkActionViewModel } from '@/features/jobs/scoping/OCRScopingJobBulkActionViewModel'
import { links } from '@/utils/link'
import {
  OCRScopeJobItem,
  OCRScopeJobItemAction,
} from '@/features/jobs/scoping/components/OCRScopeJobItem'
import type { OCRScopeWorkStatusFilterId } from '@/features/jobs/scoping/ocr-scope-work-status'

export interface OCRScopeJobItemContainerProps {
  vm: OCRScopingJobBulkActionViewModel
  mainPanelVm: OCRScopingJobMainPanelViewModel
  item: OCRScopeWork
  selectedStatusFilterId: OCRScopeWorkStatusFilterId
}

export const OCRScopeJobItemContainer = observer(
  function OCRScopeJobItemContainer({
    vm,
    mainPanelVm,
    item,
    selectedStatusFilterId,
  }: OCRScopeJobItemContainerProps) {
    return (
      <OCRScopeJobItem
        to={links.scopingJob(item.id)}
        isActive={mainPanelVm.isSelected(item)}
        jobName={vm.itemName(item)}
        subtitle={vm.itemSubtitle(item)}
        action={
          <OCRScopeJobItemAction
            canManageOCRScopingJobs={vm.canManageOCRScopingJobs}
            selectedStatusFilterId={selectedStatusFilterId}
            checked={vm.itemsSelectedForBulkAction.has(item.id)}
            onToggleItemForBulkAction={() => vm.toggleItemForBulkAction(item)}
          />
        }
      />
    )
  },
)
